<template>
    <div class="login-container">
        <div class="login-form">
            <div class="input-wrapper">
                <input v-model.trim="phone" placeholder="手机号" />
            </div>
            <div class="input-wrapper">
                <input v-model.trim="checkCode" placeholder="输入验证码" />
                <span
                    class="sendBtn"
                    @click="sendMsg"
                    v-text="
                        (!state.smsSendBtn && '获取验证码') || state.time + ' s'
                    "
                    >发送验证码</span
                >
            </div>
            <button @click="login">登录/注册</button>
        </div>
        <van-dialog
            v-model="show"
            title="请根据图形输入校验码"
            show-cancel-button
            @confirm="handleSendMsg"
        >
            <img :src="imgUrl" />
            <input style="margin-left: 10px; height: 36px" v-model="picCode" />
        </van-dialog>
    </div>
</template>
<style lang="less" scoped>
.login-container {
    padding: 15px;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .login-form {
        width: 100%;
        .input-wrapper {
            border: 1px solid #d8d8d8;
            height: 40px;
            border-radius: 10px;
            margin-bottom: 15px;
            display: flex;
            overflow: hidden;
            input {
                height: 38px;
                padding-left: 10px;
                display: table-cell;
                flex: auto;
                border: none;
            }
            .sendBtn {
                color: #17c1ce;
                float: right;
                line-height: 40px;
                padding-right: 10px;
                font-size: 12px;
            }
        }
    }
    button {
        width: 100%;
        line-height: 36px;
        color: white;
        border-radius: 10px;
        border: none;
        background: #17c1ce;
        margin-top: 80px;
    }
}
</style>
<script>
import { Notify } from "vant";
import Cookies from "js-cookie";
import { fetchCode, getSmsCaptcha, fetchLogin } from "../../services/common";

export default {
    data() {
        return {
            phone: "",
            checkCode: "",
            picCode: "",
            imgUrl: "",
            show: false,
            state: {
                time: 60,
                smsSendBtn: false,
            },
            rules: {
                phone: "",
                check: "",
            },
        };
    },
    methods: {
        getCode() {
            return fetchCode()
                .then((res) => {
                    console.log(res.data);
                    return (
                        "data:image/gif;base64," +
                        btoa(
                            new Uint8Array(res.data).reduce(
                                (data, byte) =>
                                    data + String.fromCharCode(byte),
                                ""
                            )
                        )
                    );
                })
                .then((data) => {
                    this.imgUrl = data;
                    return data;
                });
        },
        sendMsg() {
            if (this.phone === "") {
                Notify({ type: "warning", message: "手机号不能为空" });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                Notify({ type: "warning", message: "请输入正确的手机号" });
                return false;
            }
            this.getCode().then((res) => {
                this.show = true;
            });
            //
        },
        handleSendMsg() {
            if (this.picCode === "") {
                Notify({ type: "warning", message: "验证码不能为空" });
                return;
            }
            getSmsCaptcha({
                phone: this.phone,
                businessType: "app_user_login",
                checkCode: this.picCode,
            })
                .then((res) => {
                    this.show = false;
                    Notify({
                        type: "success",
                        message: "验证码已发送，请查看",
                    });
                    this.state.smsSendBtn = true;
                    const interval = window.setInterval(() => {
                        if (this.state.time-- <= 0) {
                            this.state.time = 60;
                            this.state.smsSendBtn = false;
                            window.clearInterval(interval);
                        }
                    }, 1000);
                })
                .catch(() => {
                    // this.getCode()
                    this.picCode = "";
                });
        },
        login() {
            if (this.phone === "") {
                Notify({ type: "warning", message: "手机号不能为空" });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.phone)) {
                Notify({ type: "warning", message: "请输入正确的手机号" });
                return false;
            }
            if (this.checkCode === "") {
                Notify({ type: "warning", message: "验证码不能为空" });
                return;
            }
            if (this.checkCode.length < 4) {
                Notify({ type: "warning", message: "验证码的长度至少为4位" });
                return false;
            }
            const params = {
                checkCode: this.checkCode,
                encryptedData: "",
                iv: "",
                password: this.checkCode,
                type: 0,
                username: this.phone,
            };
            fetchLogin(params).then((res) => {
                Cookies.set("mini-token", res.token);
                Cookies.set("mini-secretKey", res.secretKey);
                this.$router.push(`${this.$route.query.redirect}`);
            });
            //
        },
    },
};
</script>
